import { useAaroQuery } from './useAaroQuery';
import { getTodos } from 'services/outside/aaro/aaroDekont';

export function useTodoQueries(params, options = {}) {
    const todosQuery = useAaroQuery({
        queryKey: ['gorevler', ...Object.values(params)],
        queryFn: () =>
            getTodos({
                ...params,
            }),
        options: { ...options, requireSuccess: true },
    });

    return {
        todosQuery,
    };
}
